import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: "Home",
        products: "Products",
        about: "About",
        contact: "Contact",
        quote: "Get Quote"
      },
      hero: {
        title: "UAE's Premier Building Materials Trading Company",
        subtitle: "Excellence in Building Material Supply Chain Solutions",
        description: "Noor Altayseer provides comprehensive building materials, fixtures, and supplies across the UAE. Your trusted partner for quality construction materials and exceptional service.",
        cta: "Get Instant Quote",
        cta2: "View Products"
      },
      products: {
        title: "Our Product Categories",
        subtitle: "Comprehensive Building Materials & Construction Supplies",
        categories: {
          building: "Building & Construction Materials",
          electrical: "Electrical Fittings & Lighting Equipment",
          fixtures: "Fixtures & Fittings", 
          lighting: "Lighting Equipment & Requisites",
          stones: "Natural Stones & Marble",
          steel: "Reinforcement Steel Bars",
          sanitary: "Sanitary Ware",
          tiles: "Tiles & Flooring Materials"
        },
        viewAll: "View All Products",
        requestQuote: "Request Quote"
      },
      about: {
        title: "About Noor Altayseer",
        subtitle: "Building Excellence Since Inception",
        mission: "Our Mission",
        missionText: "To be the UAE's most trusted supplier of premium building materials and construction solutions, supporting the nation's infrastructure development with quality, reliability, and innovation.",
        values: "Our Values",
        valuesText: "Quality, Integrity, Innovation, and Customer Success drive everything we do.",
        experience: "Industry Experience",
        experienceText: "Extensive experience in the UAE construction market with deep understanding of local requirements and standards."
      },
      contact: {
        title: "Contact Us",
        subtitle: "Ready to Support Your Construction Projects",
        phone: "Phone",
        email: "Email",
        address: "Address",
        hours: "Business Hours",
        form: {
          name: "Full Name",
          email: "Email Address",
          phone: "Phone Number",
          company: "Company Name",
          message: "Message",
          submit: "Send Message"
        }
      },
      quote: {
        title: "Request a Quote",
        subtitle: "Get competitive pricing for your construction materials",
        form: {
          project: "Project Name",
          category: "Product Category",
          quantity: "Quantity",
          specifications: "Specifications",
          timeline: "Required Timeline",
          submit: "Get Quote"
        }
      }
    }
  },
  ar: {
    translation: {
      nav: {
        home: "الرئيسية",
        products: "المنتجات",
        about: "من نحن",
        contact: "اتصل بنا",
        quote: "طلب عرض سعر"
      },
      hero: {
        title: "الشركة الرائدة في تجارة مواد البناء والتشييد في دولة الإمارات",
        subtitle: "التميز في حلول سلسلة توريد البناء",
        description: "تقدم نور التيسير مواد البناء والتركيبات والمستلزمات الإنشائية الشاملة في جميع أنحاء دولة الإمارات. شريكك الموثوق لمواد البناء عالية الجودة والخدمة الاستثنائية.",
        cta: "احصل على عرض سعر فوري",
        cta2: "عرض المنتجات"
      },
      products: {
        title: "فئات منتجاتنا",
        subtitle: "مواد البناء الشاملة ومستلزمات التشييد",
        categories: {
          building: "مواد البناء والتشييد",
          electrical: "التركيبات الكهربائية",
          fixtures: "التركيبات والمستلزمات",
          lighting: "معدات الإضاءة والمستلزمات",
          stones: "الأحجار الطبيعية والرخام",
          steel: "قضبان الحديد المسلح",
          sanitary: "الأدوات الصحية",
          tiles: "البلاط ومواد الأرضيات"
        },
        viewAll: "عرض جميع المنتجات",
        requestQuote: "طلب عرض سعر"
      },
      about: {
        title: "حول نور التيسير",
        subtitle: "بناء التميز منذ البداية",
        mission: "رسالتنا",
        missionText: "أن نكون المورد الأكثر ثقة في دولة الإمارات لمواد البناء المتميزة وحلول التشييد، ودعم تطوير البنية التحتية للدولة بالجودة والموثوقية والابتكار.",
        values: "قيمنا",
        valuesText: "الجودة والنزاهة والابتكار ونجاح العملاء يقود كل ما نقوم به.",
        experience: "الخبرة في الصناعة",
        experienceText: "خبرة واسعة في سوق البناء الإماراتي مع فهم عميق للمتطلبات والمعايير المحلية."
      },
      contact: {
        title: "اتصل بنا",
        subtitle: "مستعدون لدعم مشاريعك الإنشائية",
        phone: "الهاتف",
        email: "البريد الإلكتروني",
        address: "العنوان",
        hours: "ساعات العمل",
        form: {
          name: "الاسم الكامل",
          email: "عنوان البريد الإلكتروني",
          phone: "رقم الهاتف",
          company: "اسم الشركة",
          message: "الرسالة",
          submit: "إرسال الرسالة"
        }
      },
      quote: {
        title: "طلب عرض سعر",
        subtitle: "احصل على أسعار تنافسية لمواد البناء الخاصة بك",
        form: {
          project: "اسم المشروع",
          category: "فئة المنتج",
          quantity: "الكمية",
          specifications: "المواصفات",
          timeline: "الجدول الزمني المطلوب",
          submit: "احصل على عرض السعر"
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;